import { useId } from 'react';

export interface Position {
    x: number;
    y: number;
}

export interface PositionGridInputProps {
    value: Position;
    onChange: (position: Position) => void;
    disabled?: Position[];
    bounds?: number;
}

export const PositionGridInput = ({
    value,
    onChange,
    disabled,
    bounds = 0.75,
}: PositionGridInputProps) => {
    const positionId = useId();

    return (
        <fieldset>
            <legend>Position</legend>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridTemplateRows: '1fr 1fr 1fr',
                }}
            >
                {[bounds, 0.0, -bounds]
                    .flatMap((y) =>
                        [-bounds, 0.0, bounds].map((x) => ({ x, y })),
                    )
                    .map(({ x, y }) => (
                        <input
                            key={`${x};${y}`}
                            type="radio"
                            name={positionId}
                            checked={value.x === x && value.y === y}
                            onChange={() => onChange({ x, y })}
                            disabled={
                                disabled?.some(
                                    (pos) => pos.x === x && pos.y === y,
                                ) || false
                            }
                        />
                    ))}
            </div>
        </fieldset>
    );
};
